export default __webpack_public_path__ + "static/media/beeelikegucccy- originals - dolamubadejo-2 bdic  1.23731476.png";